const stores = [
  {
    _id: "STORE001",
    storeCode: "HKSTORE001",
    storeName: "Anita's Homemade Foods",
    slug: "anitas-homemade-foods",

    entrepreneur: "Anita Sharma",
    entrepreneurId: "FH001",

    category: "Food",
    subCategory: "Homemade Foods",

    logo:
      "https://images.unsplash.com/photo-1556740749-887f6717d7e4?w=300",

    banner:
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200",

    shortDescription:
      "Traditional homemade pickles, snacks and authentic Indian recipes prepared with love.",

    locality: "Andheri West",
    city: "Mumbai",
    state: "Maharashtra",

    totalProducts: 32,
    totalOrders: 1248,

    rating: 4.8,
    totalRatings: 182,

    verified: true,
    featured: true,
    premium: true,

    pickup: true,
    localDelivery: true,
    cod: true,

    isActive: true
  },

  {
    _id: "STORE002",
    storeCode: "HKSTORE002",
    storeName: "NatureHer Essentials",
    slug: "natureher-essentials",

    entrepreneur: "Megha Joshi",
    entrepreneurId: "FH003",

    category: "Beauty",
    subCategory: "Natural Beauty",

    logo:
      "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=300",

    banner:
      "https://images.unsplash.com/photo-1522337660859-02fbefca4702?w=1200",

    shortDescription:
      "Handcrafted soaps, skincare and wellness products made using natural ingredients.",

    locality: "Baner",
    city: "Pune",
    state: "Maharashtra",

    totalProducts: 48,
    totalOrders: 2015,

    rating: 4.9,
    totalRatings: 284,

    verified: true,
    featured: true,
    premium: false,

    pickup: true,
    localDelivery: true,
    cod: true,

    isActive: true
  },

  {
    _id: "STORE003",
    storeCode: "HKSTORE003",
    storeName: "Priya Foods",
    slug: "priya-foods",

    entrepreneur: "Priya Nair",
    entrepreneurId: "FH002",

    category: "Food",
    subCategory: "Snacks",

    logo:
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=300",

    banner:
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1200",

    shortDescription:
      "Fresh homemade snacks, papads, spices and regional delicacies for every family.",

    locality: "Powai",
    city: "Mumbai",
    state: "Maharashtra",

    totalProducts: 24,
    totalOrders: 864,

    rating: 4.7,
    totalRatings: 96,

    verified: false,
    featured: false,
    premium: false,

    pickup: true,
    localDelivery: true,
    cod: true,

    isActive: true
  }
];

export default stores;